export default __webpack_public_path__ + "static/e4dc5e216c80e1c747f4b725cb5ef185.jpeg";